<template>
  <div class="documents-list" v-if="documentId">
    <h3 class="title">Required documents</h3>

      <b-message v-if="needsLinkedForm">
        <!-- if company_type is non_hk_law_firm -->
        If necessary, please create linked KYC form for target company.
          <router-link
            tag="button"
            class="button is-outlined is-primary"
            :to="{ name: 'new', query: { linked: 1 }, params: { kycId: this.documentId, jobNumber: this.jobNumber } }">
            Create linked form
          </router-link>
      </b-message>

      <div>
        <p>
          <router-link :to="`kyc/${documentId}`">Form</router-link> was created.
           Please check relevant checkbox if copy and/or original of the required
           document was provided and upload available KYC documents on this page
           before proceeding to the form.
        </p>
        <br/>
        <div class="buttons is-centered">
          <router-link
            :to="`kyc/${documentId}`"
            tag="button"
            class="button is-primary">Open KYC form</router-link>
        </div>
      </div>

      <b-table :data="documents">
          <template slot-scope="props">
            <b-table-column label="Name" field="ownerName" sortable>
              {{props.row.ownerName}}
            </b-table-column>
            <b-table-column label="Document" field="docDesc" sortable>
              {{props.row.docDesc.replace('{0}', representativeStr)}}
            </b-table-column>
            <b-table-column label="Status" width="200">
              <div class="field">
                <b-checkbox @input="setDocStatus(props.row, 'copy', $event)">Email</b-checkbox>
                <b-checkbox @input="setDocStatus(props.row, 'orig', $event)">Original</b-checkbox>
              </div>
            </b-table-column>
          </template>
      </b-table>

      <b-field class="upload-field" v-if="!docStatusesEmpty">
          <b-upload v-model="filesToUpload" @input="uploadFiles"
            multiple
            drag-drop
          >
              <section class="section">
                  <div class="content has-text-centered">
                      <p>
                          <b-icon
                            icon="upload"
                            size="is-large"
                          />
                      </p>
                      <p>Drop your files here or click to upload</p>
                  </div>
              </section>
          </b-upload>
      </b-field>

      <div v-if="uploaded.length > 0">
        Files uploaded:
        <b-table :data="uploaded">
            <template slot-scope="props">
              <b-table-column label="File" field="filename" sortable>
                {{props.row.filename}}
              </b-table-column>
              <b-table-column label="Status" field="status">
                <b-icon :icon="props.row.status ? 'check' : 'close'"/>
              </b-table-column>
            </template>
        </b-table>
      </div>

  </div>
</template>

<script>

export default {
  name: 'ListDocuments',
  props: ['listData', 'documentId', 'needsLinkedForm'],
  data () {
    return {
      documents: [],
      filesToUpload: [],
      docStatuses: [],
      uploaded: []
    }
  },
  created () {
    if (!this.documents || this.documents.length === 0) {
      this.getListOfDocuments(this.documentId)
    }
  },
  methods: {
    getListOfDocuments (kycId) {
      if (!kycId) return
      this.axios.get(`/kyc/${kycId}/reqdocs`)
        .then(response => {
          // console.log(response.data)
          this.documents = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    setDocStatus (propsRow, state, value) {
      const { entity, row, docId } = propsRow
      // console.log(entity, row, docId)
      const defaultStatuses = { 'copy': false, 'orig': false }
      let docStatus = this.docStatuses.find(s => {
        if (s.entity === entity &&
          s.row === row &&
          s.docId === docId) return true
      })
      if (!docStatus) {
        docStatus = { entity, row, docId, status: defaultStatuses }
        this.docStatuses.push(docStatus)
      }
      this.$set(docStatus['status'], state, value)
    },
    uploadFiles () {
      this.updateDocStatuses()
      this.filesToUpload.forEach(file => {
        const reader = new FileReader()
        reader.onload = () => {
          this.uploadFile(file.name, file.type, reader.result)
        }
        reader.readAsDataURL(file)
      })
    },
    uploadFile (fileName, fileType, content) {
      this.axios.post(`/kyc/${this.documentId}/upload`, {
        file_name: fileName,
        file_type: fileType,
        content
      })
        .then(response => {
          if (response.data) {
            const newUpload = { filename: fileName, status: true }
            this.uploaded.push(newUpload)
            this.$toast.open({
              'message': 'File upload successful',
              'type': 'is-success'
            })
            this.filesToUpload = []
          }
        })
        .catch(error => {
          console.log(error)
          this.$toast.open({
            'message': error.message,
            'type': 'is-danger'
          })
          const newUpload = { filename: error.response.data.filename, status: false }
          this.uploaded.push(newUpload)
        })
    },
    updateDocStatuses () {
      this.axios.post(`/kyc/${this.documentId}/doc/batch`, {
        doc_statuses: this.docStatuses
      })
        .then(response => {
          this.$toast.open({
            'message': 'Doc statuses updated successfully.',
            'type': 'is-success'
          })
        })
        .catch(error => {
          console.log(error)
          this.$toast.open({
            'message': `Error while updating doc statuses. ${error.message}`,
            'type': 'is-danger'
          })
        })
    }
  },
  computed: {
    representativeStr () {
      if (!this.listData) return ''
      const filtered = this.listData.individual
        .filter(el => { return el.role === 'representative' })
      if (!filtered || filtered.length === 0) return ''
      return filtered[0].name + ' as'
    },
    docStatusesEmpty () {
      const keys = Object.keys(this.docStatuses)
      if (keys.length === 0) return true
      return false
    }
  },
  watch: {
    documentId (val, oldVal) {
      this.getListOfDocuments(val)
    }
  }
}
</script>

<style scoped>
  .documents-list {
    width: 80%;
    margin: auto;
  }

  .documents-list h3 {
    text-align: center;
  }

  ul li {
    line-height: 1.8em;
  }

  .upload-field {
    margin-top: 2em;
  }

</style>

<style>
  .upload-draggable {
    width: 100%;
  }
</style>
